import React, { Component } from "react";
import DropdownSelect from "../main/DropdownSelect";
import { default as ReactSelect } from "react-select";
import $ from 'jquery'; 

import { ThreeDots } from 'react-loading-icons';
import { AiFillInfoCircle } from "react-icons/ai";
import { FaFolder } from "react-icons/fa";

import axios from "axios";



// SELECTED FILTERS OBJECT
export var filters_selected = { 
    tissue_sampled_filter: [],
    assay_filter: [],
    analyte_filter: [],
    event_type: [],
    event_category: [],
    material_filter: [],
    disease_filter: [],
    participant_id_filter: [],
    sex_filter: [],
    race_filter: [],
    study_id_filter: [],
    pmid_filter: [],
    authors_filter: []
}



export default class FilterDropdown extends Component {

    // create a websocket to communicated with angular finder app
    // chatSocket = new WebSocket('ws://localhost:8080/ws/chat/filters/');


    constructor(props) {

        super(props);

        this.title = props.title;
        this.id = props.id;
        this.comment = props.comment;

        // to fetch api
        this.api = props.data;
        this.loadingdata_bool = true;
        if (this.api === ''){
            this.loadingdata_bool = false;
        }

        this.example = props.example;
        this.filters_selected = filters_selected;
        this.value_selected = props.selected; // already selected filters


        this.onDropdownChange = props.onDropdownChange;

        // equivalent to useState in a react function
        this.state = {
            loadingData: this.loadingdata_bool,
            options: [],
            optionSelected: null,
            numberSelected: 0,
        };


        // showing but disabled filters
        this.disabled = false;
        if (props.disabled){
            this.disabled = true;
        }


        // POPULATE DROPDOWN WITH REAL DISTINCT DATA if there's something to populate
        async function populate_dropdown_options(url, el) {
            await axios
                .get(url)
                .then((response) => {
                    el.options = response.data;

                    if (props.selected !== null && el.options !== undefined){
                        el.value_selected = el.options.filter(function (el){
                            if (props.selected.includes(el.value)){
                                return el
                            }
                        });
                    }

                    if (el.value_selected == null) {
                        el.number_selected = 0;
                    }
                    else {
                        el.number_selected = el.value_selected.length;
                    }

                    el.filters_selected[el.id] = el.value_selected;

                    el.setState({
                        loadingData: false,
                        options: el.options,
                        optionSelected: el.value_selected,
                        numberSelected: el.number_selected,
                    });
                });
        }

        if (this.state.loadingData) {
            const url = window.location.protocol + '//' + window.location.host + '/api_kb/'+this.api; 

            populate_dropdown_options(url, this);
        }
    }

    
    handleChange = (selected) => {
        this.setState({
            optionSelected: selected,
            numberSelected: selected.length,
        });

        this.filters_selected[this.id] = selected;

        this.onDropdownChange(this.filters_selected);
    };


    showSelectedFilter = (id) => {
        if (! $("#filters-selected-" + id).hasClass('expandAllfilters')){
            // change height of input
            $('#filter-dropdown-' + id +' .css-1dyz3mf')[0].style.maxHeight = '1000px';

            $("#filters-selected-" + id).addClass('expandAllfilters');
        }

        else {
            // reset height of input
            $('#filter-dropdown-' + id +' .css-1dyz3mf')[0].style.maxHeight = '36px';

            $("#filters-selected-" + id).removeClass('expandAllfilters');

        }
    }

    // openFinder = (id) => {
    //     // window.open('http://localhost:8181/?finder='+id, 'popup', 'location=no,toolbar=no,menubar=no,width=1000,height=650,top=150,left=250');
    //     window.open('http://localhost:8181/?finder='+id, 'popup', 'location=no,width=1000,height=650,top=150,left=250');

    //     this.chatSocket.onmessage = (e) => {
    //         const data = JSON.parse(e.data);
            
    //         if (data.message_type === 'string' && data.message_from === 'finder' && data.message === 'connection success'){
    //             this.chatSocket.send(JSON.stringify({
    //                 'filter_type': 'sex_filter',
    //                 'message_type': 'data',
    //                 'message_from': 'query',
    //                 'message': this.state.optionSelected
    //             }));
    //         }

    //         else if (data.message_from === 'finder' && data.message_type === 'data') {

    //             var selection = [];
    //             if (data.message != null){
    //                 for (var s of data.message){
    //                     this.state.options.filter(function (el){
    //                         if (el.label === s.name){
    //                             selection.push(el);
    //                         }
    //                     })
    //                 }    
    //             }

    //             this.setState(
    //                 { 
    //                     optionSelected: selection,
    //                     numberSelected: selection.length
    //                 }
    //             );    
    //         }
           
    //     }
    // }


    
    render(){
        
        return (

            <div className={this.disabled ? "filter-disabled" : ""}>
                
                <div id={"filter-card-" + this.id} className={`${this.state.numberSelected > 0 ? "FilterDropdown filter-card filter-active" : "FilterDropdown filter-card"}`}>

                    <div className="filter-card-title">
                        {this.title}
                        {this.comment ? <i onMouseEnter={() => ($('#comment-'+this.id))[0].style.display = "block"} onMouseLeave={() => ($('#comment-'+this.id))[0].style.display = "none"}><AiFillInfoCircle /></i>: null}
                        {this.comment ? <p id={"comment-"+this.id}>{this.comment}</p>: null}
                    </div>
                    

                    {this.state.loadingData ? (
                        <div className="loader-dropdown">
                            <ThreeDots fill="#ccd8de" height={10}/>
                        </div>
                    ):(

                        <div className="filter-content">
                            <div id={"filter-dropdown-" + this.id} className={this.findericon ? "filter-dropdown-has-finder" : "filter-dropdown"}>
                                <span class="d-inline-block" data-toggle="popover" data-trigger="focus" data-content="Please select options" >
                                    <ReactSelect 
                                        placeholder={this.example}
                                        options={this.state.options} 
                                        isMulti 
                                        closeMenuOnSelect={false} 
                                        hideSelectedOptions={false} 
                                        components={{ DropdownSelect }} 
                                        onChange={this.handleChange} 
                                        allowSelectAll={true} 
                                        value={this.state.optionSelected} 
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                            ...theme.colors,
                                            primary25: 'var(--blue-grey)',
                                            primary: 'var(--orange)',
                                            },
                                        })}
                                    />
                                </span>
                            </div>

                            {/* {this.findericon ? 
                                <div className="finder-icon">
                                    <a onClick={() => this.openFinder(this.id)}>
                                        <FaFolder/>
                                    </a>
                                </div> 
                                
                                :  
                                null 
                            }              */}
                            
                            <div className="all-selected-filters">
                                <div className="filters-selected" onClick={() => this.showSelectedFilter(this.id)}>
                                    <div id={"filters-selected-" + this.id} title="see all filters applied" className={`${this.state.numberSelected > 0 ? "show-number-selected expandAllfilters" : ""}`}>({this.state.numberSelected})</div>
                                </div>
                            </div>

                        </div>

                    )}

                </div>

            </div>

        )

    }
}

// export default FilterDropdown;
